import BaseModel from "../../../common/script/models/BaseModel";
import Api from "../../../common/script/services/Api";

export default class TransactionModel extends BaseModel {

  /**
   * Get list url
   */
  getListUrl() {
    return 'transaction/list';
  }

  /**
     * Get details url
     */
  getDetailsUrl() {
    return 'transaction/details';
  }
  /**
   * Get default table columns
   */
  getTableColumns() {
    return [
      {
        name: 'id',
        label: 'Id',
        sortable: true,
        type: 'field'
      },
      {
        name: 'categoryName',
        label: 'Category Name',
        sortable: false,
        type: 'field'
      },
      {
        name: 'amount',
        label: 'Amount',
        sortable: false,
        type: 'field'
      },
      {
        name: 'transactionDate',
        label: 'Transaction Date',
        sortable: false,
        type: 'field'
      },
      {
        name: null,
        label: 'Actions',
        sortable: false,
        type: 'actions'
      }
    ]
  }

}



// WEBPACK FOOTER //
// ./src/modules/cards/models/TransactionsModel.js